import React from 'react';
import ReportingFinancesEventPnlPage from '../components/ReportingFinancesEventPnlPage';

const axios = require('axios').default;

const ReportingFinancesEventPnlApp = (props) => {
  if (props.csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  }
  return <ReportingFinancesEventPnlPage {...props} />;
};

export default ReportingFinancesEventPnlApp;
